import { render, staticRenderFns } from "./createCombinationOrder.vue?vue&type=template&id=2135b0a8&scoped=true"
import script from "./createCombinationOrder.vue?vue&type=script&lang=js"
export * from "./createCombinationOrder.vue?vue&type=script&lang=js"
import style0 from "./createCombinationOrder.vue?vue&type=style&index=0&id=2135b0a8&prod&scoped=true&lang=css"
import style1 from "./createCombinationOrder.vue?vue&type=style&index=1&id=2135b0a8&prod&lang=css"
import style2 from "./createCombinationOrder.vue?vue&type=style&index=2&id=2135b0a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2135b0a8",
  null
  
)

export default component.exports